export default __webpack_public_path__ + "static/media/portfolio-88.3142eafc.jpg";